<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          cols="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-robot-happy"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Machine Learning Note Level predictions for {{ sitedetails.idnum }}
              </div>
            </template>
            <v-row>
              <v-spacer />
              <v-btn
                color="warning"
                dark
                class="mb-2 mr-2"
                to="/MLManagement"
              >
                Return
              </v-btn>
            </v-row>
            <v-row>
              <v-col>
                <apexchart
                  type="line"
                  height="350"
                  :options="chartOptions"
                  :series="series"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                class="xs"
                cols="12"
                sm="12"
                md="12"
              >
                <v-data-table
                  :headers="headers"
                  :items="mldata"
                  :search="searchdaily"
                  sort-by="calories"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>ML Values</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      />
                      <v-text-field
                        v-model="searchdaily"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      />
                      <v-spacer />
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.prediction`]="{ item }">
                    {{ item.prediction }}
                  </template>
                  <template v-slot:[`item.sum`]="{ item }">
                    {{ format_amt(item.sum) }}
                  </template>
                  <template v-slot:[`item.weather`]="{ item }">
                    {{ item.weather }}
                  </template>
                  <template v-slot:no-data>
                    <div class="display-2 font-weight-light">
                      The system is still learning for Smart Safe ID {{ id }}
                    </div>
                    <br>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      loading: false,
      dialog: false,
      dialoginfo: false,
      search: '',
      searchorder: '',
      searchdaily: '',
      sitedetails: '',
      snackbar: false,
      mlresults: [],
      mlgraphdata: [],
      graphdays: [],
      graphsums: [],
      series: [],
      timeout: 5000,

      alertmessage: '',
      items: [],
      headers: [
        { text: 'Date', value: 'date', align: 'center' },
        { text: 'Day', value: 'day', align: 'left' },
        { text: 'Weather', value: 'weather', align: 'left' },
        { text: 'Prediction', value: 'prediction', align: 'center' },
        { text: 'Total', value: 'bills', align: 'left' }
      ],

      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%'
          },
        },
        stroke: {
          width: [0, 3, 9],
        },
        title: {
          text: 'Machine Learning'
        },
        colors: ['#77B6EA', '#fa075c'],
        tooltip: {
          theme: 'light',
        },
        fill: {
          type: 'gradient',
          gradient: {
            gradientToColors: ['#3bd6c6', '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
            shadeIntensity: 1,
            opacityFrom: 0.9,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: []
        },
        // labels: ['01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001', '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001', '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'],
        xaxis: {
          type: 'datetime',
          categories: [],

        },
        yaxis: [{
          title: {
            text: 'Actual Notes In',
          },
          labels: {
            formatter: function (value) {
              return numeral(value).format('0,0')
            }
          }

        }, ]
      },
    }),
    computed: {
      mldata () {
        // lets cut this thing up to how we want it

        let sitedata = this.$store.getters.cashinvalues
        console.log('SITE DATA IS ', sitedata)
        let weather = this.$store.getters.getWeather
        console.log('weather ', weather)
        this.mlresults = this.$store.getters.getmlresults
        this.mlresults.forEach(res => {
          let day = moment(res.date).format('dddd')
          res.prediction = numeral(res.prediction).format('0.00')
          Object.assign(res, { bills: 0 })
          Object.assign(res, { day: day })
          Object.assign(res, { sum: 0 })
          Object.assign(res, { weather: 'NA' })
          Object.assign(res, { icon: '' })

          // add in weather condition for that date
          let condition = ''
          let img = ''
          condition = weather.find(weather => weather.day === res.date)
          if (condition) {
            let descr = condition.conditions.forecastday[0].day.condition.text
            img = 'http:' + condition.conditions.forecastday[0].day.condition.icon
            console.log('conditions ', condition.conditions.forecastday[0].day.condition.text, res.date)
            res.weather = descr
            res.icon = img
          }
          console.log('entry ', res)
          sitedata.forEach(entry => {
            if (entry.day === res.date) {
              res.sum = entry.sum
              res.bills = entry.bills
              // Object.assign(res, {sum: entry.sum})
            }
          })
        })
        this.graphdays = [...(this.mlresults.map(data => data.date))]
        this.graphsums = [...(this.mlresults.map(data => data.bills))]
        let predictions = [...(this.mlresults.map(data => data.prediction))]
        console.log(predictions)

        this.graphsums.reverse()
        predictions.reverse()
        this.chartOptions = {
          xaxis: {
            categories: this.mlresults.map(data => data.date).reverse()
          }

        }
        // this.chartOptions.xaxis.categories = [this.graphdays]
        this.series = [{ name: 'Bill Count', type: 'column', data: [...this.graphsums] }, { name: 'Predicted', type: 'line', data: [...predictions] }]
        return this.mlresults
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 2000)
      }
    },

    created () {
      this.getsitemap(this.$route.params.id)
      this.initialize()
    },
    beforeDestroy () {
    },
    methods: {
      gettopurl (nav) {
        let url = nav + this.id
        return url
      },
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
        this.ar = this.$store.getters.postdeposits
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('YYYY-MM-DD, HH:mm:ss')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
              console.log('CITY ', this.sitedetails.city)
              this.$store.dispatch('loadweather', 'New York')
              this.$store.dispatch('loadmonthcashin', value.siteunitsprofile)

              // this.$store.dispatch('loadunitcashin', value.siteunitsprofile)
              this.$store.dispatch('loadnotecountmachinelearning', value.siteunitsprofile)
            }
          }
        }
      },
    },
  }
</script>
